var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdityaBirlaGroupLogoVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 106,
    viewBox: "0 0 192 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_581_15048)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.642 92.8593H13.0578V105.937H16.642C20.804 105.937 23.4914 103.372 23.4914 99.3965C23.4914 95.4211 20.804 92.8593 16.642 92.8593ZM15.5225 95.2312H16.5517C19.4016 95.2312 20.9695 96.705 20.9695 99.3965C20.9695 102.088 19.4016 103.565 16.5517 103.565H15.5285L15.5225 95.2312Z",
    fill: "#AB1F24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7097 92.8593H26.2119V105.937H28.7097V92.8593Z",
    fill: "#AB1F24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.045 95.2312H34.6924V105.937H37.1571V95.2312H40.7744V92.8593H31.045V95.2312Z",
    fill: "#AB1F24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4075 92.8593L47.4011 98.0824L44.3586 92.8593H41.5418L46.1522 100.744V105.937H48.6169V100.744L53.1611 92.8593H50.4075Z",
    fill: "#AB1F24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1473 99.0137C79.4599 98.686 79.7031 98.2985 79.8624 97.8743C80.0217 97.4501 80.0937 96.998 80.0742 96.5453C80.0742 94.2999 78.5063 92.8593 76.0416 92.8593H71.4372V105.937H76.3004C78.9577 105.937 80.652 104.397 80.652 102.019C80.652 100.705 80.1404 99.6466 79.1473 99.0047M75.9483 95.1951C77.0678 95.1951 77.6125 95.6441 77.6125 96.6056C77.6125 97.567 77.1641 98.0161 76.1409 98.0161H73.8989V95.1951H75.9483ZM73.932 100.319H76.171C77.4861 100.319 78.1903 100.861 78.1903 101.952C78.1903 103.043 77.5493 103.586 76.2041 103.586H73.932V100.319Z",
    fill: "#AB1F24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8402 92.8593H83.3424V105.937H85.8402V92.8593Z",
    fill: "#AB1F24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.0313 97.0245C98.0313 94.526 96.2076 92.8593 93.454 92.8593H89.295V105.937H91.7597V101.16H93.3276L96.2708 105.937H99.1207L95.8104 100.647C97.2188 99.9752 98.0193 98.6912 98.0193 97.0305M91.7146 95.2222H93.3487C94.7872 95.2222 95.4914 95.825 95.4914 97.0486C95.4914 97.8172 95.2687 98.8118 93.3487 98.8118H91.7266L91.7146 95.2222Z",
    fill: "#AB1F24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.442 92.8593H100.944V105.937H108.85V103.598H103.442V92.8593Z",
    fill: "#AB1F24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.903 101.16H138.433V102.826C137.695 103.372 136.735 103.628 135.553 103.628C133.088 103.628 131.294 101.82 131.294 99.3332C131.294 96.8467 132.992 95.0383 135.36 95.0383C137.087 95.0383 137.921 95.7105 138.496 96.3524L138.944 96.8648L140.705 95.1981L140.238 94.7189C138.989 93.3385 137.388 92.6664 135.342 92.6664C134.467 92.6591 133.6 92.8268 132.791 93.1597C131.982 93.4926 131.248 93.984 130.631 94.605C130.015 95.226 129.528 95.9641 129.2 96.7761C128.872 97.588 128.709 98.4574 128.721 99.3332C128.721 103.149 131.634 106 135.507 106C137.587 106 139.188 105.424 140.596 104.192L140.819 103.999V98.8118H134.869V101.151",
    fill: "#AB1F24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.441 96.9612C152.441 94.4597 150.618 92.793 147.864 92.793H143.705V105.873H146.167V101.096H147.738L150.681 105.873H153.528L150.232 100.584C150.914 100.264 151.487 99.751 151.879 99.108C152.272 98.465 152.468 97.7206 152.441 96.9673M146.167 95.1348H147.801C149.239 95.1348 149.907 95.7376 149.907 96.9612C149.907 97.7298 149.682 98.7244 147.801 98.7244H146.167V95.1348Z",
    fill: "#AB1F24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.274 92.6663C159.959 92.6729 158.675 93.0695 157.585 93.806C156.494 94.5425 155.646 95.586 155.148 96.8048C154.649 98.0235 154.522 99.363 154.782 100.654C155.043 101.945 155.679 103.13 156.612 104.059C157.544 104.988 158.73 105.62 160.021 105.874C161.311 106.129 162.648 105.995 163.862 105.489C165.077 104.984 166.114 104.129 166.844 103.034C167.574 101.938 167.964 100.65 167.964 99.3332C167.975 98.4517 167.81 97.5769 167.477 96.7607C167.145 95.9445 166.652 95.2035 166.028 94.5817C165.404 93.9599 164.662 93.47 163.845 93.1409C163.028 92.8119 162.154 92.6505 161.274 92.6663ZM161.274 103.628C158.866 103.628 157.115 101.82 157.115 99.3332C157.115 96.8467 158.875 95.0383 161.274 95.0383C163.672 95.0383 165.436 96.8316 165.436 99.3332C165.436 101.835 163.675 103.634 161.274 103.634",
    fill: "#AB1F24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.597 101.13C177.597 102.796 176.796 103.628 175.262 103.628C173.727 103.628 172.923 102.763 172.923 101.13V92.7839H170.459V101.193C170.459 104.11 172.349 105.967 175.274 105.967C178.199 105.967 180.089 104.077 180.089 101.193V92.7839H177.624V101.12",
    fill: "#AB1F24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.456 92.7839H183.327V105.864H185.792V101.193H187.423C190.194 101.193 192 99.5562 192 97.0034C192 94.4506 190.24 92.7839 187.456 92.7839ZM185.822 95.1258H187.39C188.831 95.1258 189.496 95.7285 189.496 96.9854C189.496 98.2422 188.792 98.8118 187.39 98.8118H185.822V95.1258Z",
    fill: "#AB1F24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 105.904H2.4316L3.521 103.212H7.6168L8.70621 105.904H11.1709L5.6005 92.3771L0 105.904ZM4.4178 101L5.57041 98.1487L6.72 101H4.4178Z",
    fill: "#AB1F24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2643 105.937H54.6959L55.7522 103.242H59.851L60.9374 105.937H63.4021L57.8347 92.4102L52.2643 105.937ZM56.649 101.063L57.8016 98.212L58.9542 101.063H56.649Z",
    fill: "#AB1F24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.418 105.904H112.853L113.942 103.212H118.038L119.127 105.904H121.58L116.01 92.3771L110.418 105.904ZM114.803 101L115.955 98.1487L117.108 101H114.803Z",
    fill: "#AB1F24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.619 52.343L144.632 60.6463L124.884 35.9954L146.937 0H162.619V52.343Z",
    fill: "#AB1F24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.619 83.0821V52.343L144.632 60.6464L162.619 83.0821Z",
    fill: "#EF7032"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.884 35.9954L96.015 0H146.937L124.884 35.9954Z",
    fill: "#EF7032"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.948 48.9463L124.851 36.0286L96.015 0.0332031V43.1324H96.2077C103.526 43.0957 110.709 45.105 116.948 48.9343",
    fill: "#FFD35D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2077 43.1113H96.015V83.0821L116.948 48.9463C110.704 45.1251 103.526 43.1058 96.2077 43.1113Z",
    fill: "#AB1F24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.438 66.2854L144.632 60.6433L124.89 35.9954L116.954 48.9553C123.709 53.0818 129.098 59.1136 132.444 66.2944",
    fill: "#EF7032"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.948 48.9463L96.015 83.1152L132.429 66.2855C129.083 59.1046 123.694 53.0729 116.939 48.9463",
    fill: "#D31F26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.632 60.6433L132.438 66.2854C134.888 71.5563 136.156 77.3009 136.151 83.1152H162.634L144.632 60.6433Z",
    fill: "#FFD35D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.015 83.0821H136.118C136.126 77.274 134.87 71.534 132.438 66.2614L96.0241 83.0881",
    fill: "#AB1F24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.444 52.343L47.4312 60.6463L67.1789 35.9954L45.129 0H29.444V52.343Z",
    fill: "#AB1F24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.444 83.0821V52.343L47.4312 60.6464L29.444 83.0821Z",
    fill: "#EF7032"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1789 35.9954L96.015 0H45.129L67.1789 35.9954Z",
    fill: "#EF7032"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0846 48.9463L67.1789 36.0286L96.015 0.0332031V43.1324H95.8224C88.5066 43.1044 81.3269 45.1131 75.0846 48.9343",
    fill: "#D31F26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8224 43.1113H96.015V83.0821L75.1177 48.9463C81.3496 45.1254 88.5155 43.1059 95.8224 43.1113Z",
    fill: "#EF7032"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6253 66.2854L47.4312 60.6433L67.1789 35.9954L75.0846 48.9131C68.3357 53.0528 62.9577 59.0963 59.6253 66.2854Z",
    fill: "#EF7032"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0846 48.9463L96.015 83.1152L59.6253 66.2855C62.9496 59.0996 68.3303 53.0647 75.0846 48.9463Z",
    fill: "#D31F26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4312 60.6433L59.6253 66.2854C57.1749 71.5563 55.9073 77.3009 55.9117 83.1152H29.429L47.4162 60.6433",
    fill: "#FFD35D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.015 83.0821H55.9117C55.9004 77.27 57.1684 71.5269 59.6253 66.2614L96.015 83.0881",
    fill: "#AB1F24"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_581_15048"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 106,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdityaBirlaGroupLogoVector);
export default __webpack_public_path__ + "static/media/AdityaBirlaGroupLogoVector.506768129ec520081b39f7ea0e00ded8.svg";
export { ForwardRef as ReactComponent };